import * as React from "react"

const MOBILE_BREAKPOINT = 768

function useMatchMaxWidth(maxWidthPx: number): boolean {
  const [matches, setMatches] = React.useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(`(max-width: ${maxWidthPx}px)`).matches
      : false,
  )

  React.useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    ) {
      return
    }
    const mql = window.matchMedia(`(max-width: ${maxWidthPx}px)`)
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [maxWidthPx])

  return matches
}

export function useIsMobile() {
  return useMatchMaxWidth(MOBILE_BREAKPOINT - 1)
}

/** <640 prev/next; <1024 one sibling; else full. Viewport — not content width. */
export type PaginationDensity = "full" | "compact" | "minimal"

export function usePaginationDensity(): PaginationDensity {
  const isMinimal = useMatchMaxWidth(639)
  const isCompact = useMatchMaxWidth(1023)
  if (isMinimal) return "minimal"
  if (isCompact) return "compact"
  return "full"
}
